module.exports = "./assets/assets/相关政策依据.5d028534.docx";